// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"110":"34af0b1a","532":"styles","874":"component---src-collection-types-page-page-js"}[chunkId] || chunkId) + "-" + {"110":"fd9b075bd312825b113d","270":"80a77dd3b1e983981124","509":"e77ea702bf03dc9ec677","532":"418d1aec02a15d3b9a4e","874":"d7719c43ab91b8aaa12f"}[chunkId] + ".js";
};